import { render, staticRenderFns } from "./wxPayment.vue?vue&type=template&id=47ec9535&scoped=true"
import script from "./wxPayment.vue?vue&type=script&lang=js"
export * from "./wxPayment.vue?vue&type=script&lang=js"
import style0 from "./wxPayment.vue?vue&type=style&index=0&id=47ec9535&prod&lang=less&scoped=true"
import style1 from "./wxPayment.vue?vue&type=style&index=1&id=47ec9535&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec9535",
  null
  
)

export default component.exports